
import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { DateAdapter } from '@angular/material/core';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';

import { EssDetailsPopupComponent } from 'src/app/shared/popups/ess-details-popup/ess-details-popup.component';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { EssDashboardPopupsComponent } from 'src/app/shared/popups/ess-dashboard-popups/ess-dashboard-popups.component';

import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';

import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { ToastrService } from 'ngx-toastr'
import { saveAs } from 'file-saver';
import * as echarts from 'echarts';
import * as XLSX from 'xlsx';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';


@Component({
  selector: 'app-employee-satisfaction-survey',
  templateUrl: './employee-satisfaction-survey.component.html',
  styleUrls: ['./employee-satisfaction-survey.component.scss'],
})
export class EmployeeSatisfactionSurveyComponent implements OnInit {

  today: Date = new Date();
  loggedInUserRole: any;
  buttonColorName: any;
  selectedTypeTabName = 'Dashboard';
  selectedTypeTabIndex = 0;
  showSetupPopup: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  subModuleButtonColor: any;
  ratingList = [
    {
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    },
  ];

  onSeletReminderOption: boolean = false;
  isShowReminderDate: any = false;

  dimensionsTemplateList = [
    {
      dimensionName: '',
      questions: [
        {
          id: null,
          question: '',
          questionNumber: null,
          questionType: null
        },
      ],
    },
  ];

  currentPageNumberOfSurveyMasterTable: any = 1;
  totalPagesOfSurveyMasterTable: any = 0;

  demo = [
    { ratings: '0' },
    { ratings: '1' },
    { ratings: '2' },
    { ratings: '3' },
    { ratings: '4' },
    { ratings: '5' },
  ];

  selectedSubTab: any = 'Completion Report';
  infoListData: any[] = []
  selectedYear: any = null;
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  selectedSurveyName: any = null;
  selectedSurveyStartDate: any = null;
  selectedSurveyEndDate: any = null;
  selectedSurveyStatus: any;
  isShowDashboardToHR: any;
  surveyDateOfJoining: any = null;
  intructionList: any = [];
  invitationEmailBody: any;
  invitationEmailSubject: any;
  submissionEmailBody: any;
  submissionEmailSubject: any;
  loggedInUserEmail: any;
  decodedPayload: any;
  constructor(private encryptionService: EncryptionService, public router: Router, private activatedroute: ActivatedRoute, private cdRef: ChangeDetectorRef,
    public dialog: MatDialog, public sharedService: SharedService,
    private loader: LoaderService,
    private httpService: HttpService, private config: Config, private fb: FormBuilder,
    private datePipe: DatePipe, private toastr: ToastrService, private pdfDownload: DownloadAsPdfService, public mobileResponsiveService: MobileResponsiveService
  ) { }
  tokenforEss: any;
  ngOnInit() {
    this.tokenforEss = this.activatedroute.snapshot.queryParamMap.get('t');
    console.log('Token:', this.tokenforEss);

    if (this.tokenforEss) {
      const payloadPart = this.tokenforEss.split('.')[1];
      this.decodedPayload = JSON.parse(atob(payloadPart));
      console.log(this.decodedPayload);
      this.selectedSurveyID = this.decodedPayload.essId;
      this.loggedInUserId = this.decodedPayload.userId;
      
      this.getessByID()
    }
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserEmail = sessionStorage.getItem('userEmail');
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'Employee') {
      this.selectedSubTab = 'Score Trend';
      this.selectedTypeTabName = 'My Master'
    } else {
      this.selectedSubTab = 'Completion Report';
      this.selectedTypeTabName = 'Dashboard';

    }
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Setup') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';

      

          // if (params?.id) {
          //   this.selectedSurveyID = params?.id;
          //   console.log("444444444...", this.selectedSurveyID);

          //   this.selectedYear = params?.year;
          //   this.selectedSurveyID = Number(this.selectedSurveyID);
          //   this.yearsOfCompanies();
          //   this.getessByID();
          // } else {
          //   this.getYearsOfCompany();
          // }
        }
      } else {
        this.showSetupPopup = false;
        this.selectedTypeTabIndex = params?.tabIndex;
    
      }
    })
  }











  createRatingAddTableRow() {
    this.ratingList.push({
      id: null,
      questionType: 'Rating Based',
      rating: null,
      ratingDefinition: ''
    });
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createRatingRemoveTableRow(index: number) {
    if (this.ratingList.length > 1) {
      this.ratingList.splice(index, 1);
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }
  isOpenEnded: boolean = false;
  isRatingBased: boolean = true;
  onQuestionTypeChange(row: any, index: any) {
    if (row.questionType === 'Open Ended') {
      this.ratingList[index].ratingDefinition = '';
    }
    this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
    this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
  }

  createTemplateAddTable() {
    this.dimensionsTemplateList.push({
      dimensionName: '',
      questions: [
        {
          id: null,
          question: '',
          questionNumber: null,
          questionType: null
        },
      ],
    });
  }

  createTemplateDeleteTable(tableIndex: number) {
    this.dimensionsTemplateList.splice(tableIndex, 1);
  }

  createTemplateAddTableRow(tableIndex: number) {
    const table = this.dimensionsTemplateList[tableIndex];
    table.questions.push({
      id: null,
      question: '',
      questionNumber: null,
      questionType: null
    });
  }

  createTemplateRemoveTableRow(tableIndex: number, rowIndex: number) {
    const table = this.dimensionsTemplateList[tableIndex];
    table.questions.splice(rowIndex, 1);
    if (table.questions.length > 0) {
      // table.questions[table.questions.length - 1].added = true;
    }
  }
  handleTypeChange(tableIndex: number, rowIndex: number, type: string) {
    const row = this.dimensionsTemplateList[tableIndex].questions[rowIndex];
    if (type === 'Rating Based') {
      // row.showOnlyRating = false;
      // row.showOnlyOpenEnded = false;
    } else if (type === 'Open Ended') {
      // row.showOnlyRating = true;
      // row.showOnlyOpenEnded = true;
    }
  }

  // -----------------------------------------Graph------------------------------------------

  showInfoPopup: any = false
  // -----------------------------------------My Master---------------------------------------
  toggleInfoPopup() {
    this.showInfoPopup = !this.showInfoPopup;
  }
  // -----------------------------------------Reports-----------------------------------------



 


  yearsOfCompany: any = [];
  selectedSurveyID: any;
  selectedYearForDemoGraphicGraph: any;
  selectedSurveyIDForDemoGraphicGraph: any;
  selectedDemoGraphicTypeForDemoGraphicGraph: any = 'Department';
  selectedYearForCompletionStatusGraph: any;
  selectedSurveyIDForCompletionStatusGraph: any;
  selectedDemoGraphicTypeForCompletionStatusGraph: any = 'Department';

  selectedYearForDimensionComparisonGraph: any;
  selectedSurveyIDForDimensionComparisonGraph: any;
  selectedYearForTrendAnalysisGraph: any;
  selectedSurveyIDForTrendAnalysisGraph: any;
  selectedYearForDemoGraphicTrendAnalysisGraph: any;
  selectedSurveyIDForDemoGraphicTrendAnalysisGraph: any = [];
  selectedDemoGraphicTypeForDemoGraphicTrendAnalysisGraph: any = 'Department';


  essNamesList: any = [];
  essNamesListForUser: any = [];
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }



  mySurveyQuestionList: any = [];
  ratingListOnRatingBased: any = [];
  isPublished: boolean = false;
  isSurveyExpired: boolean = false;





  // isSurveyCompleted(): boolean {

  //   console.log(this.selectedSurveyEndDate);

  //   if (!this.selectedSurveyEndDate) return false;
  //   const [month, year, day] = this.selectedSurveyEndDate?.split('-');
  //   console.log(this.selectedSurveyEndDate);


  //   // 04/2025/10

  //   console.log(`${month}/${day}/${year}`);

  //   const eventEndDate = new Date(`${month}/${day}/${year}`);
  //   eventEndDate.setHours(23, 59, 59, 999);

  //   console.log(eventEndDate + ' --- ' + eventEndDate.getTime());

  //   const tomorrowsDate = new Date();
  //   tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);
  //   console.log(tomorrowsDate + ' --- ' + tomorrowsDate.getTime());

  //   if (eventEndDate > tomorrowsDate) {
  //     console.log(true);
  //     return true;
  //   } else {
  //     console.log(false);
  //     return false;
  //   }

  // }


  isSurveyCompleted(): string {
    const now = new Date();


    if (!this.selectedSurveyStartDate || !this.selectedSurveyEndDate) {
      return ' ';
    }

    const startDate = new Date(this.selectedSurveyStartDate);
    const endDate = new Date(this.selectedSurveyEndDate);
    endDate.setHours(23, 59, 59, 999); // End of day



    // Not Published yet
    if (!this.isPublished) {
      return 'Pending';
    }

    // Published, but not started yet
    if (startDate > now) {
      return 'Published_Not_Started';
    }

    //Published, currently ongoing
    if (now >= startDate && now <= endDate) {
      return 'Active';
    }

    //published, and ended
    if (now > endDate) {
      return 'Completed';
    }

    return 'Pending'; // Fallback
  }







  getessByID() {
    console.log("Survey Id is 5555555..", this.selectedSurveyID);
    console.log(this.decodedPayload);

    this.httpService.callGetServiceWithoutToken(this.config.getessByIDAuth + this.selectedSurveyID).subscribe((data: any) => {
      // On API response
      const fromYear = data?.data?.fromYear;
      const toYear = data?.data?.toYear;

      if (fromYear && toYear) {
        const year = `${fromYear}-${toYear}`;
        this.selectedYear = year;

        // Avoid duplicates
        if (!this.yearsOfCompany.some((y: any) => y.year === year)) {
          this.yearsOfCompany.push({ year });
        }
      }
      this.selectedSurveyName = data?.data?.essName;
      this.essNamesListForUser.push({ id: this.selectedSurveyID, name: data?.data?.essName });
      this.selectedSurveyStartDate = data?.data?.startDate;
      this.selectedSurveyEndDate = data?.data?.endDate;
      this.selectedSurveyStatus = data?.data?.essStatus;
      this.isShowDashboardToHR = data?.data?.isReportsVisibleToHr ? data?.data?.isReportsVisibleToHr : false;
      console.log("Is show dashborad To HR...", this.isShowDashboardToHR);

      this.isPublished = data?.data?.isPublished ? data?.data?.isPublished : false;
      console.log("Checking publish......", this.isPublished)
      
      const today = new Date();
      const endDate = new Date(this.selectedSurveyEndDate);
      this.isSurveyExpired = endDate < today;

      this.selectedEmployeeId = [];
      data?.data?.employee?.forEach((ele: any) => {
        let obj = {
          id: ele
        }
        this.selectedEmployeeId.push(obj);
      })
     
      this.selectedLocationForSetup = [];
      data?.data?.location.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedLocationForSetup.push(obj)
      })
      this.selectedBandForSetup = [];
      data?.data?.band.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedBandForSetup.push(obj)
      })
      this.selectedGradeForSetup = [];
      data?.data?.grade.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedGradeForSetup.push(obj)
      })
      this.selectedFunctionForSetup = [];
      data?.data?.department.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele
        }
        this.selectedFunctionForSetup.push(obj)
      })
      this.surveyDateOfJoining = data?.data?.surveyCutoff;
      this.onSeletReminderOption = data?.data?.isReminderOn;
      this.selectedTemplateColorName = data?.data?.templateName ? data?.data?.templateName : 'Red';

      this.templateColorList.forEach((ele: any) => {
        if (ele.colorName == data?.data?.templateName) {
          this.selectedTemplateColorCode = ele.stripcolor;
          this.selectedtemplateBgColor = ele.backgroundColor;
        }
      })

      if (data?.data?.instruction?.length != 0) {
        this.intructionList = data?.data?.instruction;
      } else {
        this.intructionList = []
      }
      if (data?.data?.ratings?.length != 0) {
        this.ratingList = data?.data?.ratings;
      } else {
        this.ratingList = [
          {
            id: null,
            questionType: 'Rating Based',
            rating: null,
            ratingDefinition: ''
          },
        ]
      }
      this.isOpenEnded = this.ratingList?.some((ele: any) => ele.questionType == 'Open Ended');
      this.isRatingBased = this.ratingList?.some((ele: any) => ele.questionType == 'Rating Based');
      if (data?.data?.questions?.length != 0) {
        this.dimensionsTemplateList = data?.data?.questions;
      } else {
        this.dimensionsTemplateList = [
          {
            dimensionName: '',
            questions: [
              {
                id: null,
                question: '',
                questionNumber: null,
                questionType: null
              },
            ],
          },
        ];
      }
      this.invitationEmailBody = data?.data?.invitationEmailBody;
      this.invitationEmailSubject = data?.data?.invitationEmailSubject;
      this.submissionEmailBody = data?.data?.submissionEmailBody;
      this.submissionEmailSubject = data?.data?.submissionEmailSubject;

      this.mySurveyQuestionList = data?.data?.questions.flatMap((dimension: { questions: any; }) => dimension.questions);
      this.mySurveyQuestionList = this.mySurveyQuestionList.map((question: any) => ({
        ...question,
        answer: '' // You can set a default value or any specific value
      }));
      this.ratingListOnRatingBased = [];
      data?.data?.ratings.forEach((ele: any) => {
        if (ele.questionType == 'Rating Based') {
          this.ratingListOnRatingBased.push(ele)
        }
      })
      if (this.selectedTypeTabName == 'Dashboard') {

      }
      
   
    })
  }

  isRatingDuplicate: boolean = false;
 
  isEditActive: boolean = false;
  editSurvey() {
    this.isEditActive = true;
  }
  closeSurveyEdit() {
    this.isEditActive = false;
    this.getessByID();
  }
  selectedTemplateColorName: any = 'Red';
  selectedTemplateColorCode: any = '#F6921E';
  selectedtemplateBgColor: any;
  templateColorList = [
    {
      stripcolor: "#db4437",
      backgroundColor: "#fae3e1",
      colorName: "Red"
    },
    {
      stripcolor: "#673ab7",
      backgroundColor: "#f0ebf8",
      colorName: "Purple"
    },
    {
      stripcolor: "#3f51b5",
      backgroundColor: "#eceef8",
      colorName: "Indigo"
    }, {
      stripcolor: "#4285f4",
      backgroundColor: "#e3edfd",
      colorName: "Blue"
    },
    {
      stripcolor: "#03a9f4",
      backgroundColor: "#d9f2fd",
      colorName: "Light Blue"
    },
    {
      stripcolor: "#00bcd4",
      backgroundColor: "#d9f5f9",
      colorName: "Cyan"
    },
    {
      stripcolor: "#ff5722",
      backgroundColor: "#ffe6de",
      colorName: "Red Orange"
    },

    {
      stripcolor: "#ff9800",
      backgroundColor: "#fff0d9",
      colorName: "Orange"
    },
    {
      stripcolor: "#009688",
      backgroundColor: "#d9efed",
      colorName: "Teal"
    },
    {
      stripcolor: "#4caf50",
      backgroundColor: "#e4f3e5",
      colorName: "Green"
    },
    {
      stripcolor: "#607d8b",
      backgroundColor: "#e7ecee",
      colorName: "Blue Gray"
    },
    {
      stripcolor: "#9e9e9e",
      backgroundColor: "#f0f0f0",
      colorName: "Gray"
    },
  ]
  searchString: any = '';
  listOfEss: any = [];
  debounceTimer: any;
  selectedSizeToShowData: any = 25;
  sortByName: any;
 

  getLocationList: any = [];
  selectedLocationForSetup: any = [];
  getBandList: any = [];
  selectedBandForSetup: any = [];
  getGradeList: any = [];
  selectedGradeForSetup: any = [];
  getFunctionList: any = [];
  selectedFunctionForSetup: any = [];
  selectedEmployeeId: any = [];
 
 
  
  


  
 

  questionResponses: any = []
  searchStringReport: any = null
  onClickRating(selectedquestion: any, selectedrating: any, questionIndex: any) {
    if (!this.isResponseSubmittedMySurvey) {
      this.mySurveyQuestionList[questionIndex].answer = selectedrating.rating;
    }
  }
  private showErrorDialog(message: string): void {
  const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
    disableClose: true,
    height: '25%',
    width: window.innerWidth <= 576 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
    maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
    data: {
      msg: message,
      btn2: 'OK',
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: false,
      showSuccessMessage: false,
      showCloseIcon: false
    },
  });

  dialogRef.afterClosed().subscribe(() => {});
}

  submitMySurveyResponse() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {

      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to Submit response?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loader.dismissLoader();
        var questionResponses: { answer: any; questionId: any; }[] = []
        this.mySurveyQuestionList.forEach((ele: any) => {
          let obj = {
            answer: ele.answer,
            questionId: ele.id
          }
          questionResponses.push(obj);
        })
        var flag = true;
        if (this.mySurveyQuestionList?.some((ele: any) => ele.answer == '')) { flag = false }
        if (!flag) {
          this.toastr.error('Please fill all mandetory fields.', '', {
            timeOut: 3000,
          });
          return
        }
        const request = {
          "essId": this.selectedSurveyID,
          "questionResponses": questionResponses,
          "userId": this.loggedInUserId
        }
        // this.loader.simpleLoader();
      this.httpService.callPostServiceWithoutToken(this.config.isResponseSubmittedAuth, request)
  .subscribe({
    next: (data: any) => {
      // Success case
      if (data?.status) {
        this.isResponseSubmittedMySurvey = true;
        this.isResponseSubmitted();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 576 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });

        successdialogRef.afterClosed().subscribe(() => {
          this.isEditActive = false;
          this.router.navigate(['welcome']);
        });
      } else {
        // API returned status false
        this.showErrorDialog(data?.message || 'Response already submitted for this survey.');
      }
    },
    error: (error) => {
      // Handle server or network error
      this.loader.dismissLoader();
      console.error('Error response:', error);

      let errorMessage = 'Something went wrong. Please try again later.';
      if (error?.error?.message?.includes('Response already submitted')) {
        errorMessage = 'Response already submitted for this survey.';
      }

      this.showErrorDialog(errorMessage);
    }
  });

      }
    });
  }
 
  






  isResponseSubmittedMySurvey: boolean = false;
  submissionDate: any;
  isResponseSubmitted() {
    const test = this.selectedYear?.split('-');
    this.httpService.callGetServiceWithoutToken(this.config.isResponseSubmittedForAuth + this.selectedSurveyID + '/' + this.loggedInUserId).subscribe((data: any) => {
      this.isResponseSubmittedMySurvey = data?.data?.isSubmit;
      this.submissionDate = data?.data?.submissionDate ? data?.data?.submissionDate : null;
    })
  }




  



 

  
 
 


}



